import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/TopStores';

export const TOP_STORES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const TOP_STORES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const TOP_STORES_VIEW = `${rootActionPath}/VIEW`;
